const styles = {
  container:
    'relative w-full bg-[#E84F31] py-16 md:py-12 flex items-center justify-center text-white',
  content:
    'p-12 md:px-24 sm:py-16 text-center flex flex-col items-center gap-y-4 z-10 w-full',
  title: 'md:text-2xl font-bold',
  link: 'text-sm hover:bg-white/30 duration-300 flex flex-row items-center gap-x-2 bg-white/20 px-4 py-3 rounded-xs',
  image: 'object-cover group-hover:scale-105 transition-all duration-300 -z-1',
};

export default styles;
